import { render, staticRenderFns } from "./GnralSetting.vue?vue&type=template&id=5ea07338&"
import script from "./GnralSetting.vue?vue&type=script&lang=js&"
export * from "./GnralSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports